var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.active
      ? _c("div", { staticClass: "files-viewer" }, [
          _c("div", {
            staticClass: "files-viewer__mask",
            on: { click: _vm.close },
          }),
          _vm.activeFile
            ? _c(
                "div",
                { staticClass: "files-viewer__container" },
                [
                  _c(
                    "div",
                    { staticClass: "files-viewer__file" },
                    [
                      _c("file-viewer", {
                        staticClass: "file-view",
                        attrs: { file: _vm.activeFile },
                      }),
                      _vm.activeFile.name
                        ? _c("div", { staticClass: "files-viewer__label" }, [
                            _vm._v(_vm._s(_vm.activeFile.name)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "files-viewer__actions" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "files-viewer__action files-viewer__download",
                        attrs: {
                          href: _vm.activeFile.url,
                          target: "_blank",
                          download: "",
                        },
                      },
                      [_c("svg-icon", { attrs: { name: "upload" } })],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "files-viewer__action files-viewer__close",
                        on: { click: _vm.close },
                      },
                      [_c("svg-icon", { attrs: { name: "times" } })],
                      1
                    ),
                  ]),
                  _vm.files.length > 1
                    ? [
                        _c(
                          "button",
                          {
                            staticClass:
                              "files-viewer__control files-viewer__prev",
                            on: { click: _vm.prev },
                          },
                          [
                            _c("svg-icon", {
                              attrs: { name: "arrow-left", size: "lg" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "files-viewer__control files-viewer__next",
                            on: { click: _vm.next },
                          },
                          [
                            _c("svg-icon", {
                              attrs: { name: "arrow-right", size: "lg" },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }